import { AppBar, Box, Icon, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';

import { useOnlineStatus } from "../../Lib/Network/useOnlineStatus";
import { OnlineStatus } from "../../Lib/Network/types";
import { ToolbarFlowOrientation } from "../../Settings/settingsTypes";
import { useSettings } from "../../Settings/useSettings";


interface PopupAppBarProps {
    title: string;
    icon: JSX.Element;
    showNetworkStatus?: boolean;
    onClose: () => void;
}

const PopupAppBar = (props: PopupAppBarProps): JSX.Element => {

    const settings = useSettings();

    const onlineStatus = useOnlineStatus();
    const orientation = settings.ui.toolbarFlowOrientation;

    return (
        <AppBar sx={{ position: 'relative', direction: orientation === ToolbarFlowOrientation.RightHanded ? 'ltr' : 'rtl'}}>
            <Toolbar>

                {props.icon}

                <Typography sx={{ ml: 2, mr: 2, flex: 1 }} variant="h6" component="div">{props.title}</Typography>

            {props.showNetworkStatus === true &&
                <Box sx={{ marginX: 3 }}>
                    {onlineStatus === OnlineStatus.Online && <Icon title="You are online"><WifiIcon /></Icon>}
                    {onlineStatus === OnlineStatus.Offline && <Icon title="You are offline"><WifiOffIcon /></Icon>}
                </Box>
            }
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={props.onClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>

            </Toolbar>
      </AppBar>
    );
};

export default PopupAppBar;